<template>
    <AnagraficaCrud titolo="Valori limite di trasmittanza" endpoint="valori-limite" nuovo-label="Nuova zona"
        :colonne="colonne" :campi="campi" :puo-scrivere="true"
        colonne-import="Zona, Serramento2006, Serramento2008, Serramento2010, Vetro2006, Vetro2008, Vetro2011, Detrazione2009, Detrazione2010" />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

export default {
    name: "ValoriLimitePage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Zona", key: "zona" },
                { title: "Serr. 2006", key: "serramento2006" },
                { title: "Serr. 2008", key: "serramento2008" },
                { title: "Serr. 2010", key: "serramento2010" },
                { title: "Vetro 2006", key: "vetro2006" },
                { title: "Vetro 2008", key: "vetro2008" },
                { title: "Vetro 2011", key: "vetro2011" },
                { title: "Detr. 2009", key: "detrazione2009" },
                { title: "Detr. 2010", key: "detrazione2010" },
            ],
            campi: [
                { key: "zona", label: "Zona climatica", tipo: "text", required: true, cols: 12 },
                { key: "serramento2006", label: "Serramenti Uw 2006", tipo: "number" },
                { key: "serramento2008", label: "Serramenti Uw 2008", tipo: "number" },
                { key: "serramento2010", label: "Serramenti Uw 2010", tipo: "number" },
                { key: "vetro2006", label: "Vetri Ug 2006", tipo: "number" },
                { key: "vetro2008", label: "Vetri Ug 2008", tipo: "number" },
                { key: "vetro2011", label: "Vetri Ug 2011", tipo: "number" },
                { key: "detrazione2009", label: "Detrazione 55% Uw 2009", tipo: "number" },
                { key: "detrazione2010", label: "Detrazione 55% Uw 2010", tipo: "number" },
            ],
        };
    },
};
</script>
